import React, { useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { createStyles, makeStyles, Theme, useTheme } from "@material-ui/core/styles";
import { Button, DialogActions, Grid, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import { ErrorType, selectError, selectUnavailable } from "../../redux/slices/cleverlynkSlice";
import useCleverlynkFunctions from "../../hooks/useCleverlynkFunctions";
import useFavicon from "../../hooks/useFavicon";

const UnavailableDialog = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const error = useSelector(selectError);
  const unavailable = useSelector(selectUnavailable);

  const { setFavicon } = useFavicon();

  const { handleModifyUnavailable } = useCleverlynkFunctions();

  useEffect(() => {
    if (unavailable?.closed) {
      setFavicon(unavailable?.image ?? "", "¡Estamos cerrados!");
    }
  }, [unavailable]);

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      dialogContent: {
        overflowX: "hidden",
        backgroundColor: unavailable?.backgroundColor,
        padding: isMobile ? 0 : 40,
        paddingBottom: isMobile ? 8 : 40,
        width: isMobile ? "100%" : 300,
      },
      dialogText: {
        color: unavailable?.textColor,
        textAlign: "center",
        whiteSpace: "break-spaces",
      },
      dialogTitle: {
        color: unavailable?.textColor,
        textAlign: "center",
        fontWeight: "bold",
      },
      dialogImage: {
        width: 300,
        OObjectFit: "contain",
        maxHeight: "40vh",
      },
      fullScreenPaper: {
        maxHeight: "90%",
      },
    })
  );

  const handleClose = () => {
    if (error?.data?.hours) {
      handleModifyUnavailable({ open: false, closed: true });
    }
  };

  let classes = useStyles();

  return error?.type === ErrorType.STORE_CLOSED ||
    error?.type === ErrorType.STORE_UNAVAILABLE ||
    ErrorType["404_NOT_FOUND"] ? (
    <Dialog
      classes={{ paperFullScreen: classes.fullScreenPaper }}
      open={Boolean(unavailable?.open)}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title">
      <DialogContent className={classes.dialogContent}>
        <Grid container justifyContent="center">
          <img src={unavailable?.image || ""} alt="unavailable dialog" className={classes.dialogImage} />
        </Grid>
        <div style={{ marginTop: 24 }}>
          <Typography className={classes.dialogTitle} variant="h5"></Typography>
          {unavailable?.title}
        </div>
        <div style={{ marginTop: 24 }}>
          <Typography className={classes.dialogText} variant="body1">
            {unavailable?.subtitle || ""}
          </Typography>
        </div>
      </DialogContent>
      {unavailable?.url && (
        <DialogActions>
          <Grid container direction="column" alignItems="center">
            <Grid item>
              <Button variant="contained" color="primary" href={unavailable.url}>
                Contáctanos por Whatsapp
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      )}
      {unavailable && unavailable.closed && (
        <DialogActions>
          <Grid container direction="column" alignItems="center">
            <Grid item>
              <Button variant="contained" color="primary" onClick={handleClose}>
                Ver Tienda
              </Button>
            </Grid>
            <Grid>
              <Typography display="block" variant="caption">
                No podrás comprar productos
              </Typography>
            </Grid>
          </Grid>
        </DialogActions>
      )}
    </Dialog>
  ) : null;
};
export default UnavailableDialog;
